import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { FaPause, FaPlay } from "react-icons/fa";
import { RiDeleteBinLine } from "react-icons/ri";
import { pdpApiInstance } from "../../axiosInstances";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import { Toast } from "react-bootstrap";

const ReviewPlaylistModal = ({
  show,
  handleClose,
  selectedPlaylist,
  playlist,
  id,
  fetchNotReviewedVideosCOunr,
  fetchreviewdata,
  getPlaylist,
  VideoId,
}) => {
  const modalRef = useRef(null);
  const [moderatingObj, setModeratingObj] = useState(null);
  const [reviewVideos, setReviewVideos] = useState([]);
  const [selectedVideos, setSelectedVideos] = useState([]);
  const [isClosing, setIsClosing] = useState(false);
  const [draggedVideo, setDraggedVideo] = useState(null);
  const [playinVideoId, setPlayinVideoId] = useState(null);
  const [loading, setLoading] = useState(false);
  // const [videos,   setSelectedVideos] = useState(selectedVideos);

  // useEffect(() => {
  //   const data = reviewVideos.filter((video) => VideoId.includes(video.id));
  //   setSelectedVideos(data);
  // }, [reviewVideos, VideoId]);
  const sequenceOrder = playlist[0].videos;
  // useEffect(() => {
  //   if (sequenceOrder?.length) {
  //     // Ensure sequenceOrder is available
  //     setSelectedVideos(
  //       [...sequenceOrder].sort((a, b) => a.sequenceOrder - b.sequenceOrder)
  //     );
  //   }
  // }, [sequenceOrder]); // Depend on sequenceOrder to update when it changes

  // Debugging: Log selectedVideos after state updates
  // useEffect(() => {
  //   console.log("Updated selectedVideos:", selectedVideos);
  // }, [selectedVideos]);

  useEffect(() => {
    const data = reviewVideos
      .filter((video) => VideoId.includes(video.id))
      .sort((a, b) => {
        const orderA =
          sequenceOrder.find((item) => item.videoId === a.id)?.sequenceOrder ||
          Infinity;
        const orderB =
          sequenceOrder.find((item) => item.videoId === b.id)?.sequenceOrder ||
          Infinity;
        return orderA - orderB;
      });

    setSelectedVideos(data);
  }, [reviewVideos, VideoId, sequenceOrder]);

  const handleDragStart = (index) => {
    setDraggedVideo(index);
  };

  const handleDragEnter = (index) => {
    if (draggedVideo !== null && Array.isArray(selectedVideos)) {
      const updatedVideos = [...selectedVideos];
      const draggedItem = updatedVideos.splice(draggedVideo, 1)[0];
      updatedVideos.splice(index, 0, draggedItem);
      setSelectedVideos(updatedVideos);
      setDraggedVideo(index);
    }
  };

  useEffect(() => {
    const modalElement = modalRef.current;
    if (modalElement) {
      if (show) {
        modalElement.classList.add("slide-down");
        modalElement.classList.remove("slide-up");
      } else {
        modalElement.classList.add("slide-up");
        modalElement.classList.remove("slide-down");
      }
    }
  }, [show, handleClose]);

  const handleCloseed = () => {
    const modalElement = modalRef.current;
    if (modalElement) {
      modalElement.classList.add("slide-up");
      setTimeout(() => {
        setIsClosing(false);
        handleClose();
      }, 500);
    }
  };

  const formatDuration = (durationInSeconds) => {
    const minutes = Math.floor(durationInSeconds / 60);
    const seconds = durationInSeconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
      2,
      "0"
    )}`;
  };

  const fetchData2 = async (pageNumber, tag) => {
    // if (tag !== "viewmore") {
    //   setLoading(true);
    //   // Reset the page number to 1 and clear the existing videos if not loading more
    //   if (pageNumber === 1) {
    //     setReviewVideos([]); // Clear the existing videos
    //   }
    // }

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL_PDP}/api/moderator/videos/product-title?title=`,
        {
          headers: {
            Authorization: localStorage.getItem("token")
              ? localStorage.getItem("token")
              : "",
          },
        }
      );

      setReviewVideos(res.data.data);

      if (tag !== "viewmore") {
        setTimeout(() => {
          setLoading(false);
        }, 700);
      }
    } catch (error) {
      console.error("Error fetching videos:", error);
    }
  };
  useEffect(() => {
    fetchData2();
  }, []);

  const handleVideoClick = (videoId) => {
    if (playinVideoId === videoId) {
      setPlayinVideoId(null); // Pause the video
    } else {
      setPlayinVideoId(videoId); // Play the video
    }
  };

  const cdnUrl = process.env.REACT_APP_S3_CDN;
  const toggleVideoSelection = (video) => {
    // setSelectedVideos((prevSelected) => {
    //   if (prevSelected.includes(video)) {
    //     return prevSelected.filter((v) => v !== video);
    //   } else {
    //     return [...prevSelected, video];
    //   }
    // });
    setSelectedVideos((prevSelected) => {
      if (prevSelected?.includes(video)) {
        return prevSelected?.filter((v) => v !== video);
      } else {
        return [...prevSelected, video];
      }
    });
  };
  const handleUpdatePlaylist = async () => {
    try {
      const payload = {
        videos: selectedVideos.map((video, index) => ({
          videoId: video.id,
          sequenceOrder: index + 1,
        })),
      };

      const response = await axios.put(
        `  ${process.env.REACT_APP_API_URL_PDP}/api/playlists/${selectedPlaylist.id}`,
        payload,
        {
          headers: {
            Authorization: localStorage.getItem("token")
              ? localStorage.getItem("token")
              : "",
          },
        }
      );

      toast.success("Updated Successfully");
      handleCloseed();
      setTimeout(() => {
        getPlaylist();
      }, 1000);
    } catch (error) {
      console.error("Error updating playlist:", error);
    }
  };

  if (!show && !isClosing) return null;

  return (
    <div className="review-modal-overlay">
      <div
        className="review-modal-content"
        ref={modalRef}
        style={{ height: "85vh" }}
      >
        <button className="review-modal-close" onClick={handleCloseed}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="34"
            height="34"
            viewBox="0 0 44 44"
            fill="none"
          >
            <rect width="44" height="44" rx="22" fill="white" />
            <g clipPath="url(#clip0_483_11622)">
              <path
                d="M22 20.586L26.95 15.636L28.364 17.05L23.414 22L28.364 26.95L26.95 28.364L22 23.414L17.05 28.364L15.636 26.95L20.586 22L15.636 17.05L17.05 15.636L22 20.586Z"
                fill="#454549"
              />
            </g>
            <defs>
              <clipPath id="clip0_483_11622">
                <rect
                  width="24"
                  height="24"
                  fill="white"
                  transform="translate(10 10)"
                />
              </clipPath>
            </defs>
          </svg>
        </button>

        <>
          <h5
            className="ps-2 mt-3 mb-1"
            style={{ fontWeight: "600px", fontSize: "18px" }}
          >
            Change the sequence of videos placement by dragging and dropping
            positions.
          </h5>
          <div
            className="row"
            style={{
              flexWrap: "wrap",
              height: "calc(100% - 80px)",
              overflow: "auto",
            }}
          >
            {selectedVideos.map((video, index) => (
              <div
                key={video.id}
                className="col-2 mt-3"
                style={{ position: "relative" }}
                id={`videocard_${video.id}`}
                draggable
                onDragStart={() => handleDragStart(index)}
                onDragEnter={() => handleDragEnter(index)}
                onDragOver={(e) => e.preventDefault()}
                onClick={() => toggleVideoSelection(video)}
              >
                <div>
                  <div
                    className="playlist w-100"
                    style={{
                      boxShadow: "0.3px 0.3px 2px 1px #E8E8E8",
                      borderRadius: "10px",
                      borders: "5px 5px 0 5px",
                      outline: "5px solid #334499",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={selectedVideos.includes(video)}
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleVideoSelection(video);
                      }}
                      style={{ zIndex: "1" }}
                    />
                    <div className="position-relative">
                      {loading ? (
                        <img
                          className="w-100"
                          style={{ borderRadius: "10px 10px 0 0" }}
                          src="https://cdn-product-images.goswirl.live/default-video-thumbnail.webp"
                          alt="cover"
                        />
                      ) : (
                        <video
                          className="w-100"
                          style={{
                            objectFit: "cover",
                            borderRadius: "10px 10px 0px 0px",
                          }}
                          poster={
                            video.coverImage
                              ? `${cdnUrl}${video.coverImage}`
                              : "https://cdn-product-images.goswirl.live/default-video-thumbnail.webp"
                          }
                          ref={(ref) => {
                            if (ref) {
                              if (playinVideoId === video.id) {
                                ref.play();
                              } else {
                                ref.pause();
                              }
                            }
                          }}
                          muted
                        >
                          <source
                            src={
                              video.assetKey
                                ? `${cdnUrl}${video.assetKey}`
                                : video.assetKey
                            }
                            type="video/mp4"
                          />
                          Your browser does not support the video tag.
                        </video>
                      )}
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          handleVideoClick(video.id);
                        }}
                        className="pointer_cursor"
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          textAlign: "center",
                          color: "white",
                          display: loading ? "none" : "block",
                          zIndex: 1,
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: "#FFFFFF",
                            height: "50px",
                            width: "50px",
                            display: "grid",
                            placeItems: "center",
                            borderRadius: "50%",
                          }}
                        >
                          {playinVideoId === video.id ? (
                            <FaPause size={20} color="#09121F" />
                          ) : (
                            <FaPlay size={20} color="#09121F" />
                          )}
                        </div>
                      </div>
                      <div
                        className="badge position-absolute mb-4 m-1 p-1"
                        style={{
                          bottom: "30px",
                          right: "10px",
                          backgroundColor: "rgba(23, 23, 28, 0.7)",
                        }}
                      >
                        {formatDuration(video.duration)}
                      </div>
                      <div
                        className="title_video_select"
                        style={{
                          paddingLeft: "10px",
                          paddingTop: "3px",
                          paddingBottom: "6px",
                        }}
                      >
                        {video.title ? video.title : "No-Title"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {reviewVideos
              ?.filter(
                (video) => !selectedVideos.some((v) => v.id === video.id)
              )
              .map((video) => (
                <div
                  key={video.id}
                  className="col-2 mt-3"
                  style={{ position: "relative" }}
                >
                  <div>
                    <div
                      className="playlist w-100"
                      style={{
                        boxShadow: "0.3px 0.3px 2px 1px #E8E8E8",
                        borderRadius: "10px",
                        borders: "5px 5px 0 5px",
                        outline: selectedVideos.some((el) => el.id === video.id)
                          ? "5px solid #334499"
                          : "none",
                      }}
                      onClick={() => toggleVideoSelection(video)}
                    >
                      <input
                        type="checkbox"
                        // checked={false}
                        checked={selectedVideos.some(
                          (el) => el.id === video.id
                        )}
                        onClick={() => toggleVideoSelection(video)}
                        onChange={() => toggleVideoSelection(video)}
                        style={{ zIndex: "1" }}
                      />
                      <div className="position-relative">
                        {loading ? (
                          <img
                            className="w-100"
                            style={{ borderRadius: "10px 10px 0 0" }}
                            src="https://cdn-product-images.goswirl.live/default-video-thumbnail.webp"
                            alt="cover"
                          />
                        ) : (
                          <video
                            className="w-100"
                            style={{
                              objectFit: "cover",
                              borderRadius: "10px 10px 0px 0px",
                            }}
                            poster={
                              video.coverImage
                                ? `${cdnUrl}${video.coverImage}`
                                : "https://cdn-product-images.goswirl.live/default-video-thumbnail.webp"
                            }
                            ref={(ref) => {
                              if (ref) {
                                if (playinVideoId === video.id) {
                                  ref.play();
                                } else {
                                  ref.pause();
                                }
                              }
                            }}
                            muted
                          >
                            <source
                              src={
                                video.assetKey
                                  ? `${cdnUrl}${video.assetKey}`
                                  : video.assetKey
                              }
                              type="video/mp4"
                            />
                            Your browser does not support the video tag.
                          </video>
                        )}
                        {/* <video
                    className="h-100 w-100"
                    style={{
                      borderRadius: "10px 10px 0 0",
                      objectFit: "cover",
                      width: "100%",
                    }}
                  >
                    <source
                      src={
                        video.assetKey
                          ? `${cdnUrl}${video.assetKey}`
                          : video.assetKey
                      }
                    />
                  </video> */}
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                            handleVideoClick(video.id);
                          }}
                          className="pointer_cursor"
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            textAlign: "center",
                            color: "white",
                            display: loading ? "none" : "block",
                            zIndex: 1,
                          }}
                        >
                          <div
                            style={{
                              backgroundColor: "#FFFFFF",
                              height: "50px",
                              width: "50px",
                              display: "grid",
                              placeItems: "center",
                              borderRadius: "50%",
                            }}
                          >
                            {playinVideoId === video.id ? (
                              <FaPause size={20} color="#09121F" />
                            ) : (
                              <FaPlay size={20} color="#09121F" />
                            )}
                          </div>
                        </div>
                        <div
                          className="badge position-absolute mb-4 m-1 p-1"
                          style={{
                            bottom: "30px",
                            right: "10px",
                            backgroundColor: "rgba(23, 23, 28, 0.7)",
                          }}
                        >
                          {formatDuration(video.duration)}
                        </div>
                        <div
                          className="title_video_select"
                          style={{
                            paddingLeft: "10px",
                            paddingTop: "3px",
                            paddingBottom: "6px",
                          }}
                        >
                          {video.title ? video.title : "No-Title"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
          <div className=" d-flex gap-2 pt-2">
            <button
              onClick={handleCloseed}
              className="btn btn-light"
              style={{
                color: "rgba(51, 68, 153, 1)",
                backgroundColor: "white",
                border: "none",
              }}
            >
              Back
            </button>
            <button
              onClick={handleUpdatePlaylist}
              className="btn btn-dark"
              disabled={selectedVideos.length == 0}
            >
              Submit
            </button>
          </div>
        </>
      </div>
    </div>
  );
};

export default ReviewPlaylistModal;
